import { render, staticRenderFns } from "./RelationshipStrip.vue?vue&type=template&id=7cdffe3a"
import script from "./RelationshipStrip.vue?vue&type=script&lang=js"
export * from "./RelationshipStrip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports